import React from 'react';
import { Package, Sparkles, Truck, Droplets } from 'lucide-react';
import { Button } from './ui/button';

const ServicesSection = () => {
  const services = [
    {
      icon: Package,
      title: 'Complete Decluttering',
      description: 'Sort through years of accumulated items and decide what stays, what goes to donation, and what gets tossed.',
      included: true
    },
    {
      icon: Sparkles,
      title: 'Professional Organization',
      description: 'Everything sorted into labeled, organized bins so you can actually find what you need.',
      included: true
    },
    {
      icon: Truck,
      title: 'Donation Drop-Off',
      description: 'We handle the donation center drop-off for eligible items—no stress, no extra trips.',
      included: true
    },
    {
      icon: Droplets,
      title: 'Premium Add-Ons',
      description: 'Heavy items removal, deep sweeping, and pressure washing available to make your garage shine.',
      included: false
    }
  ];

  return (
    <section className="py-20 px-4 bg-gradient-to-b from-slate-50 to-white">
      <div className="container mx-auto max-w-7xl">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-emerald-50 text-emerald-700 px-4 py-2 rounded-full text-sm font-medium mb-4 border border-emerald-100">
            <Sparkles className="h-4 w-4" />
            <span>Our Services</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Garage Cleaning & Organization Services
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            From chaotic mess to organized space—we handle it all so you don't have to
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <div 
                key={index}
                className="bg-white p-8 rounded-xl shadow-lg border border-slate-200 hover:shadow-2xl transition-all duration-300"
              >
                <div className="flex items-start gap-6">
                  <div className="bg-emerald-100 w-14 h-14 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Icon className="h-7 w-7 text-emerald-600" />
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-3 mb-3">
                      <h3 className="text-2xl font-bold text-slate-900">{service.title}</h3>
                      {service.included && (
                        <span className="bg-emerald-100 text-emerald-700 text-xs font-bold px-2 py-1 rounded-full">
                          INCLUDED
                        </span>
                      )}
                    </div>
                    <p className="text-slate-600 text-lg leading-relaxed">{service.description}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="bg-emerald-600 text-white p-8 md:p-12 rounded-2xl text-center">
          <h3 className="text-3xl md:text-4xl font-bold mb-4">
            Don't Pay Until You're Proud to Leave Your Garage Door Open!
          </h3>
          <p className="text-xl text-emerald-100 mb-6 max-w-2xl mx-auto">
            100% satisfaction guaranteed. Only pay when you absolutely love the results.
          </p>
          <Button 
            size="lg"
            className="bg-white text-emerald-600 hover:bg-emerald-50 px-8 py-6 text-lg font-semibold"
            onClick={() => document.querySelector('#quote-form')?.scrollIntoView({ behavior: 'smooth' })}
          >
            Request Your FREE Quote
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;